import axios from 'axios'
import store from '../stores/reduxStore'
import {API_BASE_URL} from './apiConfig'
import gql from 'graphql-tag'
import _ from 'lodash'

function getAccessToken() {
  let redux_store = JSON.parse(JSON.stringify(store.getState()))
  if(redux_store.user.data != null) {
    return redux_store.user.data.auth_token
  }
}

function Client() {
  return axios.create({
    baseURL: API_BASE_URL,
    timeout: 5000,
    headers: { Authorization: `Bearer ${getAccessToken()}` }
  })
}

function buildFormData(attachable_id, attachable_type, files, attachment_type) {
  let formData = new FormData()
  formData.append('files[attachable_type]', attachable_type)
  attachment_type && formData.append('files[attachment_type]', attachment_type)

  let attachable_ids_arr = _.flatten([attachable_id])
  for (let i = 0; i < attachable_ids_arr.length; i++) {
    formData.append('files[attachable_id][]', attachable_ids_arr[i])
  }

  for (let i = 0; i < files.length; i++) {
    formData.append('files[files_data][]', files[i])
  }
  return formData
}

export function UploadFiles(attachable_id, attachable_type, files, options, attachment_type = '') {
  return Client().post('/uploads', buildFormData(attachable_id, attachable_type, files, attachment_type), options).then(response => response.data)
}
export default UploadFiles

export function UploadOrReplaceFiles(attachable_id, attachable_type, files, options, attachment_type = '') {
  return Client().put('/uploads', buildFormData(attachable_id, attachable_type, files, attachment_type), options).then(response => response.data)
}

export const acceptedFiles = 'image/png,image/jpeg,application/pdf,image/vnd.dwg,application/dwg,drawing/dwg,.dwg'
export const acceptedFilesIcons = ['png', 'jpg', 'jpeg', 'pdf', 'dwg']

export const acceptedLogoFiles = 'image/png,image/jpeg,image/svg+xml,image/bmp'
export const acceptedLogoFilesIcons = ['png', 'jpg', 'jpeg', 'svg', 'bmp']

export function updateAttachemntsInStore(client, objectId, objectType, {newAttachments = [], removeAttachments = []}) {
  let AttachmentsFragment = gql`
  fragment AttachmentsParts on ${objectType} {
    attachments {
      id
      data_file_name
      url
    }
  }`

  newAttachments.map(att => att.__typename = 'Attachment')
  const currentAttachments = client.readFragment({
    id: `${objectType}:${objectId}`,
    fragment: AttachmentsFragment
  })

  client.writeFragment({
    id: `${objectType}:${objectId}`,
    fragment: AttachmentsFragment,
    data: {
      attachments: [...currentAttachments.attachments.filter(att => !removeAttachments.includes(Number(att.id))), ...newAttachments],
      __typename: objectType
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/uploadFiles.js